const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.newmont.forwoodsafety.com',
    USER_TOKEN_URL: 'https://jggak5vede.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://4058v2huyk.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.staging.newmont.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.staging.newmont.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.staging.newmont.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.staging.newmont.forwoodsafety.com',
    WEBSOCKET: 'wss://qie4vjq8uj.execute-api.us-west-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
